import "@aws-amplify/ui-react/styles.css";
import { Authenticator, withAuthenticator } from '@aws-amplify/ui-react';
import { useEffect } from 'react';
import { fetchAuthSession } from "aws-amplify/auth"

function SignIn() {

    useEffect(() => {
        let isSubscribed = true;
        fetchUser(isSubscribed);
        return () => {
            isSubscribed = false;
        }
    }, []);

    const fetchUser = async (isSubscribed: boolean) => {
        if (!isSubscribed) return;
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString() ?? '';
        setTimeout(() => {
            if (isSubscribed) window.location.href = "/";
        }, 300);
    }

    return (
        <Authenticator

        />
    )
}
export default withAuthenticator(SignIn, {
    signUpAttributes: ['email'],
    loginMechanisms: ['email']
});